define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var tmpl = require('tmpl');

    var Template = function(name, data, view) {
        if (arguments.length === 2) {
            this.data = {};
            this._template = arguments[0];
            this._view = arguments[1];
        } else {
            this.data = data;
            this._template = tmpl[name](data);
            this._view = view;
        }

        this._createWrapper();
    };

    Template.prototype = {
        getSource: function() {
            return this._template;
        },

        toString: function() {
            return this._wrapper.innerHTML;
        },

        getNodes: function() {
            var nodes = this._wrapper.childNodes;

            nodes.toString = this.toString.bind(this);
            nodes.replace = this.replace.bind(this);
            nodes.getSource = this.getSource.bind(this);

            return nodes;
        },

        replace: function() {
            var view, params;
            var dynamicTags = Playtech.Variables.dynamicTags || {};

            var source = this.toString().replace(/\[([A-Za-z\-_0-9]+)(?:\(([A-Za-z\-\+_0-9,]+)\)|)]/gm,
                function(match, replacerName, replacerParams) {
                    var dTag;
                    if (dTag = dynamicTags[replacerName]) {
                        return dTag;
                    }
                    return '<span class="_replacer" data-params="' + (replacerParams || '') + '">' + replacerName
                        + '</span>';
                });

            this._setWrapperInnerHtml(source);
            var elements = this._wrapper.querySelectorAll('._replacer');

            [].forEach.call(elements, function(node) {
                var replacerName = node.innerHTML;
                params = node.dataset.params ? node.dataset.params.split(',') : [];
                if (this._view.replacers[replacerName]) {
                    view = new this._view.replacers[replacerName]($.extend({}, this.data, {
                        name: replacerName,
                        params: params,
                        parentNode: node.parentNode
                    }));
                    this._view.childViews.push(view);
                    node.parentNode.replaceChild(view.render.apply(view, params).el, node);
                }
            }.bind(this));

            return this.getNodes();
        },

        /**
         * Creates suitable wrapper to build DOM from given html string.
         * Wrapper itself is never returned to the user
         * @returns {HTMLElement}
         * @private
         */
        _createWrapper: function() {
            this._tagName = this._template.startsWith('<tr') ? 'tbody' : 'div';
            this._wrapper = document.createElement(this._tagName);
            this._setWrapperInnerHtml(this._template);
        },

        /**
         * Sets wrapper's innerHTML without recreating it for performance sake
         * @param html
         * @private
         */
        _setWrapperInnerHtml: function(html) {
            this._wrapper.innerHTML = html;
        }
    };

    module.exports = Template;
});
